import React, { useEffect, useState } from "react";
import DashboardStyle from "../Dashboard";
import { customFuncsApi } from "../../../api";
import { Empty, Input } from "antd";
import moment from "moment";
import { useTranslation } from "react-i18next";
import ClipLoader from "react-spinners/ClipLoader";
import Button from "../../../components/Button";
import { formatNumber } from "../../../utils/formatNumber";
import { debouncedSearch } from "../../../utils/debounce";

export default function Tab5() {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);

  const [startDate, setStartDate] = useState(
    moment().startOf("month").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [customerName, setCustomerName] = useState("");
  const [serialNumber, setSerialNumber] = useState("");
  const [customerNameInput, setCustomerNameInput] = useState("");
  const [serialNumberInput, setSerialNumberInput] = useState("");

  const [invoiceData, setInvoiceData] = useState([]);
  const [invoicePage, setInvoicePage] = useState(0);

  const getInvoiceReports = (
    startDate,
    endDate,
    customerName,
    serialNumber,
    page
  ) => {
    setIsLoading(true);

    customFuncsApi
      .get("xsSql/getPaymentReportV2", {
        params: {
          startDate: startDate + " 00:00:00.000Z",
          endDate: endDate + " 00:00:00.000Z",
          customerName: customerName || undefined,
          serialNumber: serialNumber || undefined,
          $skip: page * 20,
        },
        headers: {
          Prefer: "odata.maxpagesize=20",
        },
      })
      .then((res) => {
        setInvoiceData(res.data.value || []);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    setInvoicePage(0);
  }, [startDate, endDate, customerName, serialNumber]);

  useEffect(() => {
    getInvoiceReports(
      startDate,
      endDate,
      customerName,
      serialNumber,
      invoicePage
    );
  }, [startDate, endDate, customerName, serialNumber, invoicePage]);

  const onCustomerNameChange = (e) => {
    const v = e.target.value;
    setCustomerNameInput(v);
    debouncedSearch(v, setCustomerName);
  };

  const onSerialNumberChange = (e) => {
    const v = e.target.value;
    setSerialNumberInput(v);
    debouncedSearch(v, setSerialNumber);
  };

  const newDatas = () => {
    if (invoiceData.length < 20) {
      alert(t("noOtherInfo"));
    } else {
      setInvoicePage((prev) => prev + 1);
    }
  };

  const oldData = () => {
    if (invoicePage > 0) {
      setInvoicePage((prev) => prev - 1);
    } else {
      alert(t("noOtherInfo"));
    }
  };


  // ✅ COLUMNS (NEW API)
  const columns = [
    {
      title: t("clientCode"),
      dataIndex: "Код клиента",
      key: "clientCode",
    },
    {
      title: t("clientName"),
      dataIndex: "Имя клиента",
      key: "clientName",
    },
    {
      title: "Телефон",
      dataIndex: "U_Telephone",
      key: "phone",
    },
    {
      title: "Марка авто",
      dataIndex: "Марка авто",
      key: "carBrand",
    },
    {
      title: t("serialNum"),
      dataIndex: "Серийный номер",
      key: "serialNumber",
    },
    {
      title: "Номер авто",
      dataIndex: "Номер авто",
      key: "carNumber",
    },
    {
      title: "Дата оплаты",
      dataIndex: "Дата оплаты",
      key: "paymentDate",
						render: (v) => v && moment(v).format("DD.MM.YYYY"),
    },
    {
      title: "Сумма по графику",
      dataIndex: "Сумма по графику",
      key: "schedule",
      render: (v) => formatNumber(v),
    },
    {
      title: "Просрочка (после скидки)",
      dataIndex: "Просрочка(Просрочка после скидки)",
      key: "delayAfterDiscount",
      render: (v) => formatNumber(v),
    },
    {
      title: "Оплачено за месяц",
      dataIndex: "Оплачено за месяц",
      key: "paidMonth",
      render: (v) => formatNumber(v),
    },
    {
      title: "Переплата за месяц",
      dataIndex: "Переплата за месяц",
      key: "overpayMonth",
      render: (v) => formatNumber(v),
    },
    {
      title: "Недоплата за месяц",
      dataIndex: "Недоплата за месяц",
      key: "underpayMonth",
      render: (v) => formatNumber(v),
    },
    {
      title: "Общий недоплата",
      dataIndex: "Общий недоплата",
      key: "totalUnderpay",
      render: (v) => formatNumber(v),
    },
    {
      title: "Просрочка всего",
      dataIndex: "Просрочка всего",
      key: "totalDelay",
      render: (v) => formatNumber(v),
    },
    {
      title: "Просрочено месяцев",
      dataIndex: "Просрочено месяцев",
      key: "overdueMonths",
						render: (v) => formatNumber(v),
    },
  ];

  return (
    <DashboardStyle>
      <div className="container minWidthContainer">
        <h4 className="font-bold text-lg text-center mt-10 mb-4">
          {t("paymentReports")}
        </h4>

        <div className="mb-4 flex items-end gap-10 justify-end flex-wrap">
          <div className="flex flex-col gap-2">
            <span>{t("clientName")}</span>
            <Input
              allowClear
              placeholder={t("clientName")}
              value={customerNameInput}
              onChange={onCustomerNameChange}
            />
          </div>

          <div className="flex flex-col gap-2">
            <span>{t("serialNum")}</span>
            <Input
              allowClear
              placeholder={t("serialNum")}
              value={serialNumberInput}
              onChange={onSerialNumberChange}
            />
          </div>

          <div className="flex flex-col gap-2">
            <span>{t("startDate")}</span>
            <Input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </div>

          <div className="flex flex-col gap-2">
            <span>{t("endDate")}</span>
            <Input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>
        </div>

        {isLoading ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <ClipLoader
              loading={true}
              size={20}
              aria-label="Loading Spinner"
              className={"loader"}
              data-testid="loader"
            />
          </div>
        ) : (
          <div className="overflow-auto mb-8 mt-8 max-h-[70vh] relative">
            <table className="w-full text-sm text-left rtl:text-right text-gray-500">
              <thead className="text-xs text-gray-700 uppercase bg-gray-50 sticky top-0 z-10">
                <tr>
                  {columns.map((col) => (
                    <th
                      key={col.key}
                      scope="col"
                      className="px-6 py-4 bg-gray-50 whitespace-nowrap"
                    >
                      {col.title}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {invoiceData.length > 0 ? (
                  invoiceData.map((row, i) => (
                    <tr
                      key={row["Код клиента"] ?? i}
                      className="bg-white border-b hover:bg-gray-50"
                    >
                      {columns.map((col) => (
                        <td
                          key={col.key}
                          className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap"
                        >
                          {col.render
                            ? col.render(row[col.dataIndex], row, i)
                            : row[col.dataIndex]}
                        </td>
                      ))}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={columns.length}>
                      <Empty
                        description={t("noInfo")}
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                      />
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}

        <div className="flex items-center gap-2">
          <Button className="btn" onClick={oldData}>
            {"<"}
          </Button>
          <span>{invoicePage + 1}</span>
          <Button className="btn" onClick={newDatas}>
            {">"}
          </Button>
        </div>
      </div>
    </DashboardStyle>
  );
}